var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKiosk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    height: 18,
    id: "Layer_1",
    viewBox: "0 0 18 18",
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .fill {\n        fill: #6e6e6e;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "S_Shop_18_N") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    fill: "#ff13dc",
    opacity: 0,
    width: 18,
    height: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M17.46972,8H.53027a.4.4,0,0,1-.38458-.50989l1.75067-6.1275A.5.5,0,0,1,2.37714,1H15.62286a.5.5,0,0,1,.48078.36261l1.75067,6.1275A.4.4,0,0,1,17.46972,8ZM15,9v3H7V9H6v7H3V9H2v7a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V9ZM2,7H3L4,2H3ZM6.25,7h1l.5-5h-1Zm4-5,.5,5h1l-.5-5ZM15,2H14l1,5h1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosk);
export default __webpack_public_path__ + "static/media/Kiosk.2521868ba26af65702c61d1693e4e7c0.svg";
export { ForwardRef as ReactComponent };